import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, FormControl, Validators } from '@angular/forms';

import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { stateOptionsSample, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { AUTO_CODE, AUTO_CODE_PART } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organization } from 'src/app/models/um/organization';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-set-format',
  templateUrl: './set-format.component.html',
  styleUrls: ['./set-format.component.scss']
})
export class SetFormatComponent implements OnInit {
  formFields;
  stateOptions = stateOptionsSample;
  numberOfParts = [{ "value": 0, "label": "select" }, { "value": 1, "label": "1" }, { "value": 2, "label": "2" }, { "value": 3, "label": "3" }];
  seperator = [{ "value": '', "label": "select" }, { "value": "-", "label": "-" }, { "value": "/", "label": "/" }, { "value": ":", "label": ":" }];
  partsType = [{ "value": 0, "label": "select" }, { "value": 1, "label": "Static" }, { "value": 2, "label": "Dynamic" }, { "value": 3, "label": "Counter" }];
  formats = [{ "value": 0, "label": "select" }, { "value": 3, "label": "3" }, { "value": 4, "label": "4" }, { "value": 5, "label": "5" }];
  cResetFrenquency = [{ "value": 3, "label": "Yearly" }, { "value": 4, "label": "Never" }];
  valueType = [{ "value": "YYYY", "label": "YYYY" }, { "value": "MM-YYYY", "label": "MM-YYYY" }, { "value": "DD-MM-YYYY", "label": "DD-MM-YYYY" }];
  setFormatForm = new UntypedFormGroup({});
  Content: any;
  heading: string;
  action: Subject<any> = new Subject();
  autocode: AUTO_CODE;
  programname: string;
  featurename: string;
  isSeperator: boolean;
  counter1: number;
  counter2: number;
  counter3: number;
  iscounter: boolean = false;
  isdynamic: boolean = false;
  iscnt: boolean = false;
  cnt: any = [];
  ProgramsList: any = [];
  OrgDetail: Organization
  constructor(
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private commonService: CommonService,
    private userService: UserService
  ) { }
  ngOnInit() {
    //debugger
    this.OrgDetail = this.commonService.getOrganizationObject(this.userService.getOrgCode());
    if (this.Content.heading == "Edit") {
      this.getIDConfgiData();
    }
    else {
      this.autocode = new AUTO_CODE();
      this.autocode.MODULE_ID = "";
      this.autocode.SUB_MODULE = "";
      this.autocode.NUMBER_OF_PARTS = 0;
      this.autocode.FEATURE_ID = "";
      this.autocode.SEPARATOR = "";
      this.autocode.AUTO_CODE_PART = [];
      this.autocode.RECORD_STATEBool = true;
      this.isSeperator = false;
    }

    this.programModuleState();
  }
  programModuleState() {
    if (this.Content.heading == "Edit" && this.Content.feature=="Registrations") {
      this.ProgramsList = [{ "value": "2", "label": this.OrgDetail.IST_DISPLAY_NAME },
        { "value": "4", "label": this.OrgDetail.GRANTS_DISPLAY_NAME }
       ];
    }
    else
    {
      this.summaryService.GetData("api/common/getapptypemodules").subscribe((res) => {
        this.ProgramsList = res;
       
      })
    }
  }
  getIDConfgiData() {
    this.summaryService.getCCodeSummary(this.Content.id).subscribe((result) => {
      this.autocode = result;
      if(this.Content.feature=="Registrations")
      {
        this.autocode.SUB_MODULE=this.autocode.MODULE_CODE;
      }
      this.autocode.RECORD_STATEBool = this.autocode.RECORD_STATE == 1 ? true : false;
      this.programname = this.Content.program;
      this.featurename = this.Content.feature;
      this.autocode.FEATURE_NAME = this.featurename ;
      this.counter1 = result.APPREG_COUNT1;
      this.counter2 = result.APPREG_COUNT2;
      this.counter3 = result.APPREG_COUNT3;
      this.cnt = [{ "value": result.APPREG_COUNT1, "label": result.APPREG_COUNT1 },
      { "value": result.APPREG_COUNT2, "label": result.APPREG_COUNT2 },
      { "value": result.APPREG_COUNT3, "label": result.APPREG_COUNT3 }];

      if (result.NUMBER_OF_PARTS == 1) {
        this.isSeperator = true;
      }
    });
  }
  save(): void {
    this.formulate();
    if (this.validateControls()) {
      this.autocode.RECORD_STATE = this.autocode.RECORD_STATEBool ? 1 : 0;
      if (this.Content.heading == "Add") {
        this.summaryService.insertAutocode(this.autocode).subscribe((result) => {
          if(result.Status === 0)
          {
            this.commonService.SuccessBanner('ID Format added successfully');
            this.modalRef.close();
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
          }
          });
      }
      else {
        this.autocode["PROGRAM_NAME"] = this.programname;
        this.autocode["FEATURE_NAME"] = this.featurename;
        this.summaryService.updateAutocode(this.autocode).subscribe((result) => {
          if (result.Status == 0) {
            this.commonService.SuccessBanner('ID for ' +
              "'" + this.programname + '-' + this.featurename + "'"
              + ' is successfully set to ' + this.autocode.CODE_FORMAT);
              this.modalRef.close();
          }
          else {
            this.commonService.ValidationBanner(result.Message);
          }

        });
      }

    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    this.iscounter = false;
    this.isdynamic = false;
    this.iscnt = false;
    if ((this.autocode.NAME == null || this.autocode.NAME == undefined || this.autocode.NAME == "") || this.autocode.NAME.trim().length == 0) {
      message += "Please enter Name.<br/>";
      isValid = false;
    }
    if (this.autocode.SUB_MODULE == null || this.autocode.SUB_MODULE == undefined || this.autocode.SUB_MODULE == "") {
      message += "Please select Program.<br/>";
      isValid = false;
    }
    if (this.autocode.NUMBER_OF_PARTS == null || this.autocode.NUMBER_OF_PARTS == undefined || this.autocode.NUMBER_OF_PARTS == 0) {
      message += "Please select No Of Parts.<br/>";
      this.iscounter = true;
      isValid = false;
    }
    if (this.autocode.SEPARATOR == null || this.autocode.SEPARATOR == undefined || this.autocode.SEPARATOR == "") {
      message += "Please select separator.<br/>";
      isValid = false;
    }
    for (let i = 0; i < this.autocode.AUTO_CODE_PART.length; i++) {
      if (this.autocode.AUTO_CODE_PART[i].PART_TYPE == null || this.autocode.AUTO_CODE_PART[i].PART_TYPE == undefined) {
        message += "Please select Part Type for Part " + (i + 1) + ".<br/>";
        isValid = false;
      }
      else {
        switch (this.autocode.AUTO_CODE_PART[i].PART_TYPE) {
          case 1:
            if (this.autocode.AUTO_CODE_PART[i].VALUE == null || this.autocode.AUTO_CODE_PART[i].VALUE == undefined || this.autocode.AUTO_CODE_PART[i].VALUE == "") {
              message += "Please enter Value for Part " + (i + 1) + ".<br/>";
              isValid = false;
            }
            break;
          case 2:
            this.isdynamic = true;
            if (this.autocode.AUTO_CODE_PART[i].VALUE == null || this.autocode.AUTO_CODE_PART[i].VALUE == undefined || this.autocode.AUTO_CODE_PART[i].VALUE == "") {
              message += "Please select Value for Part " + (i + 1) + ".<br/>";
              isValid = false;
            }
            break;
          case 3:
            this.iscounter = true;
            if (this.autocode.AUTO_CODE_PART[i].COUNTER_LENGTH == null || this.autocode.AUTO_CODE_PART[i].COUNTER_LENGTH == undefined) {
              message += "Please select Format (Digits) for Part " + (i + 1) + ".<br/>";
              isValid = false;
            }

            if (this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE == null || this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE == undefined) {
              message += "Please enter counter Start value for Part " + (i + 1) + ".<br/>";
              isValid = false;
            }

           

            if (this.autocode.AUTO_CODE_PART[i].COUNTER_RESET_BY != 4) {
              this.iscnt = true;
            }

            if (this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE != null || this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE != undefined) {
              var count = this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE.toString().length;
              if (this.autocode.AUTO_CODE_PART[i].COUNTER_LENGTH < count) {
                message += "The digits in value field should be less than the number selected in format field. Please update the details to save the configuration for part '" + (i + 1) + "'.<br/>";
                isValid = false;
                this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE = null;
              }
              else {
                if (this.Content.heading == "Edit") {
                  if ((this.autocode.AUTO_CODE_PART[i].OLD_COUNTER_START_VALUE!=this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE) && (this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE < this.cnt[i].value)) {
                    message += "The application id’s have already reached to digits '" + this.cnt[i].value + "' and hence cannot be configured with a lower value for part '" + (i + 1) + "'.<br/>";
                    isValid = false;
                  }
                }

                if (this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE < 1) {
                  message += "Counter start value should not less than 1 for part '" + (i + 1) + "'.<br/>";
                  isValid = false;
                  this.autocode.AUTO_CODE_PART[i].COUNTER_START_VALUE = null;
                }
              }
            }
            break;
        }
      }
    }
    if (!this.iscounter) {
      message += "At least one of the parts should have counter for saving ID Configuration<br/>";
      isValid = false;
    }
    if (this.iscounter && !this.isdynamic && this.iscnt)// && this.autocode.NUMBER_OF_PARTS != 1)
    {
      message += "Adding at least one dynamic part is mandatory when counter with reset value is selected to save the configuration<br/>";
      isValid = false;
    }
    if (message.length > 0) {
      this.commonService.ValidationBanner(message);
    }
    return isValid;
  }

  formulate(): void {
    var format = "";
    for (let i = 0; i < this.autocode.AUTO_CODE_PART.length; i++) {
      switch (this.autocode.AUTO_CODE_PART[i].PART_TYPE) {
        case 1:
          format += this.autocode.AUTO_CODE_PART[i].VALUE;
          break;
        case 2:
          format += "[" + this.autocode.AUTO_CODE_PART[i].VALUE + "]";
          break;
        case 3:
          format += "["
          for (let j = 0; j < this.autocode.AUTO_CODE_PART[i].COUNTER_LENGTH; j++) {
            format += "#";
          }
          format += "]"
          break;
      }
      format += this.autocode.SEPARATOR;
    }
    this.autocode.CODE_FORMAT = format.substring(0, format.length - 1);
  }

ProgramChange(event)
{
  let selectedProgram= event.value;
   switch(selectedProgram)
   {
     case "IST":
      this.autocode.FEATURE_ID="201";
      this.autocode.SUB_MODULE="IST";
      this.autocode.MODULE_CODE="2";
      this.autocode.FEATURE_NAME="All Applications";
      break;
     case "GRANTSCME":
      this.autocode.FEATURE_ID="401";
      this.autocode.MODULE_CODE="4";
      this.autocode.SUB_MODULE="GRANTSCME";
      this.autocode.FEATURE_NAME="All Applications";
      break;
     case "GRANTSSPONSORSHIP":
      this.autocode.FEATURE_ID="401";
      this.autocode.MODULE_CODE="4";
      this.autocode.SUB_MODULE="GRANTSSPONSORSHIP";
      this.autocode.FEATURE_NAME="All Applications";
      break;
     case "GRANTSCHARITABLE":
      this.autocode.FEATURE_ID="401";
      this.autocode.MODULE_CODE="4";
      this.autocode.SUB_MODULE="GRANTSCHARITABLE";
      this.autocode.FEATURE_NAME="All Applications";
      break;
     case "EAP":
      this.autocode.FEATURE_ID="501";
      this.autocode.MODULE_CODE="5";
      this.autocode.SUB_MODULE="EAP";
      this.autocode.FEATURE_NAME="All Applications";
      break;
   }
   this.programname = this.OrgDetail.IST_DISPLAY_NAME;
   this.featurename = this.autocode.FEATURE_NAME;


  }
  NoPartsChange(event) {
    let selectNoParts = event.value;
    if (selectNoParts != 1) {
      this.isSeperator = false;

    }
    else {
      this.isSeperator = true
      this.autocode.SEPARATOR = "-";
    }
    if (this.autocode.NUMBER_OF_PARTS != null && this.autocode.NUMBER_OF_PARTS != undefined) {
      this.autocode.AUTO_CODE_PART = [];
      for (let i = 0; i < this.autocode.NUMBER_OF_PARTS; i++) {
        let part = new AUTO_CODE_PART();
        part.AUTO_CODE_ID = this.autocode.ID;
        part.PART_TYPE = i + 1;
        part.PART_ORDER = i + 1;
        this.autocode.AUTO_CODE_PART.push(part);
      }
      this.autocode.CODE_FORMAT = "";
    }


  }
 

}
